// extracted by mini-css-extract-plugin
module.exports = {"normal":"Group_normal__2QP-8","title":"Group_title__1kg5a"};